import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReSubscribeModalComponent } from './resubscribe-modal/resubscribe-modal.component';
import { SubscribFailModalComponent } from './subscribefail-modal/subscribefail-modal.component';
import { UnsubscribeModalComponent } from './unsubscribe-modal/unsubscribe-modal.component';
import { UnsubscribeComponent } from './unsubscribe.component';

export const UNSUBSCRIBE_ROUTES: Routes = [
    {
        path: '',
        component: UnsubscribeComponent,
        children: [
            {
                path: 'resubscribe',
                component: ReSubscribeModalComponent
            },
            {
                path: 'unsubscribe/:token',
                component: UnsubscribeModalComponent
            },
            {
                path: 'subscribefail',
                component: SubscribFailModalComponent
            },
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(UNSUBSCRIBE_ROUTES)
    ],
    exports: [
        RouterModule
    ]
})
export class UnsubscribeRoutingModule {}
